/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNotification = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9.911 18.587c.405.895 1.201 1.434 2.134 1.413.906-.01 1.667-.53 2.035-1.393l1.84.786c-.68 1.589-2.156 2.588-3.853 2.607h-.048c-1.703 0-3.205-.987-3.93-2.587zM12 2c3.86 0 7 3.141 7 6.999.003 2.516.699 6.001 2 6.001v2H3v-2c1.413 0 2-3.908 2-6 0-3.859 3.14-7 7-7zm0 2C9.243 4 7 6.243 7 9c0 .537-.048 3.811-1.178 6h12.355c-1.054-2.043-1.166-5.031-1.176-5.857L17 9c0-2.757-2.243-5-5-5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgNotification as Notification };
